import Cookie from 'js-cookie'

const getQueryParams = () => {
  const params = {}
  window.location.href.replace(
    /([^(?|#)=&]+)(=([^&]*))?/g,
    ($0, $1, $2, $3) => {
      params[$1] = $3
    }
  )
  return params
}

export const setToken = token => {
  if (!process.browser) return
  window.localStorage.setItem('token', token)
  Cookie.set('token', token)
}

export const unsetToken = () => {
  if (!process.browser) return
  window.localStorage.removeItem('token')
  window.localStorage.removeItem('secret')
  window.localStorage.setItem('logout', Date.now())
  Cookie.remove('token')
}

export const getTokenFromCookie = req => {
  if (!req.headers.cookie) return
  const jwtCookie = req.headers.cookie
    .split(';')
    .find(c => c.trim().startsWith('token='))
  if (!jwtCookie) return
  return jwtCookie.split('=')[1]
}

export const getTokenFromLocalStorage = () => window.localStorage.token

export const setSecret = secret => window.localStorage.setItem('secret', secret)
